// Import the necessary functions from the Firebase SDK
import { getFirestore, connectFirestoreEmulator, collection, addDoc, doc, setDoc, getDoc } from "firebase/firestore";
import { app } from "./app"; // Import the initialized app
import { toISODate } from "../utils/utils";

// Initialize Firestore
const db = getFirestore(app);

// Connect to the Firestore emulator in development mode
if (process.env.NODE_ENV === 'development') {
  try {
    connectFirestoreEmulator(db, "localhost", 8080);
  } catch (error) {
    console.error("Error connecting to Firestore emulator:", error);
  }
}

/**
 * Saves a report to the 'reports' collection. Can create a new report or update an existing one.
 * @param {object} reportData The report data to save.
 * @param {string} [reportId] The ID of the report to update. If not provided, a new report will be created.
 * @returns {Promise<string>} The ID of the document.
 */
export const saveReport = async (reportData, reportId) => {
  try {
    if (reportId) {
      // Update existing document
      const reportRef = doc(db, "reports", reportId);
      await setDoc(reportRef, reportData, { merge: true });
      //console.log("Report updated with ID: ", reportId, reportData);
      return reportId;
    } else {
      // Create new document
      const docRef = await addDoc(collection(db, "reports"), reportData);
      console.log("Report saved with ID: ", docRef.id, reportData);
      return docRef.id;
    }
  } catch (e) {
    console.error("Error saving document to reports collection: ", e);
    throw e;
  }
};

/**
 * Fetches a report from the 'reports' collection.
 * @param {string} reportId The ID of the report to fetch.
 * @returns {Promise<object|null>} The report data or null if not found.
 */
// ─── firestore service ─────────────────────────────────────────
export const getReport = async (reportId) => {
  const snap = await getDoc(doc(db, 'reports', reportId));
  if (!snap.exists()) return null;

  // 1️⃣ add the id AND normalise any Timestamps here
  const data = snap.data();
  return {
    id: snap.id,
    ...data,
    // convert Firestore Timestamps → ISO strings that <input type="date"> likes
    dateOfBirth : toISODate(data.dateOfBirth),
    incidentDate: toISODate(data.incidentDate)
    // todo: convert any other dates
    /* …any others… */
  };
};




export { db };